import React from 'react';
import {
  Box,
  Typography,
  makeStyles,
} from '@material-ui/core';


const useStyles = makeStyles(() => {
  return {
    banner: {
      position: 'absolute',
      width: '100%',
      height: '85%',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'rgba(0, 0, 0, .95)',
      zIndex: '99999',
    },
    message: {
      fontSize: 20,
      width: '90%',
    },
  };
});

const GroupShowNotAvailableOverlay = ({ anchorName }) => {
  const classes = useStyles();
  const nickname = anchorName.replace(/ /g, '');

  return (
    <Box
      alignItems="center"
      className={classes.banner}
      display="flex"
      justifyContent="center"
    >
      <Typography className={classes.message}>
        {anchorName} is currently in a Virtual Party Show with a guest. Use your Fan Zone credentials to <a href={`https://tempted.com/profile/${nickname}`} rel="noopener noreferrer" target="_blank">join them!</a>
      </Typography>
    </Box>
  );
};

export default GroupShowNotAvailableOverlay;
